/**
 * Add action drawer.
 *
 * TODO: make dynamic
 * 
 * @package Ninja Forms builder
 * @subpackage Actions
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'views/actions/drawer/addAction',['views/actions/drawer/typeCollection', 'models/app/typeCollection'], function( actionTypeCollectionView, actionTypeCollection ) {

	var view = Marionette.LayoutView.extend( {
		template: '#tmpl-nf-drawer-content-add-action',

		regions: {
			primary: '#nf-drawer-primary',
			core: '#nf-drawer-primary-core',

			management: '#nf-drawer-secondary-management',
			payments: '#nf-drawer-secondary-payments',
			automation: '#nf-drawer-secondary-automation',
			marketing: '#nf-drawer-secondary-marketing',
			crms: '#nf-drawer-secondary-crms',
			notifications: '#nf-drawer-secondary-notifications',
		},

		initialize: function() {
			this.listenTo( nfRadio.channel( 'drawer' ), 'filter:actionTypes', this.filteractionTypes );
			this.listenTo( nfRadio.channel( 'drawer' ), 'clear:filter', this.removeactionTypeFilter );
		
			this.installedActions = nfRadio.channel( 'actions' ).request( 'get:installedActions' );
			this.updateInstalledActionGroups();

			this.availableActions = nfRadio.channel( 'actions' ).request( 'get:availableActions' );
			this.updateAvailableActionGroups();
		},

		onShow: function() {
			this.primary.show( new actionTypeCollectionView( { collection: this.primaryCollection } ) );
			this.core.show( new actionTypeCollectionView( { collection: this.coreCollection } ) );

			this.payments.show( new actionTypeCollectionView( { collection: this.paymentsCollection } ) );
			this.marketing.show( new actionTypeCollectionView( { collection: this.marketingCollection } ) );
			this.management.show( new actionTypeCollectionView( { collection: this.managementCollection } ) );
			this.crms.show( new actionTypeCollectionView( { collection: this.crmCollection } ) );
			this.notifications.show( new actionTypeCollectionView( { collection: this.notificationsCollection } ) );
			this.automation.show( new actionTypeCollectionView( { collection: this.automationCollection } ) );		
		},

		getEl: function() {
			return jQuery( this.el ).parent();
		},

		filteractionTypes: function( filteredInstalled, filteredAvailable ) {
			this.installedActions = filteredInstalled;
			this.updateInstalledActionGroups();
			this.primary.reset().show( new actionTypeCollectionView( { collection: this.primaryCollection } ) );
			this.core.reset().show( new actionTypeCollectionView( { collection: this.coreCollection } ) );

			this.availableActions = filteredAvailable;
			this.updateAvailableActionGroups();
			this.payments.reset().show( new actionTypeCollectionView( { collection: this.paymentsCollection } ) );
			this.marketing.reset().show( new actionTypeCollectionView( { collection: this.marketingCollection } ) );
			this.management.reset().show( new actionTypeCollectionView( { collection: this.managementCollection } ) );
			this.crms.reset().show( new actionTypeCollectionView( { collection: this.crmCollection } ) );
			this.notifications.reset().show( new actionTypeCollectionView( { collection: this.notificationsCollection } ) );
			this.automation.reset().show( new actionTypeCollectionView( { collection: this.automationCollection } ) );	
			
		},

		removeactionTypeFilter: function () {
			this.installedActions = nfRadio.channel( 'actions' ).request( 'get:installedActions' );
			this.updateInstalledActionGroups();
			this.primary.show( new actionTypeCollectionView( { collection: this.primaryCollection } ) );
			this.core.show( new actionTypeCollectionView( { collection: this.coreCollection } ) );

			this.availableActions = nfRadio.channel( 'actions' ).request( 'get:availableActions' );
			this.updateAvailableActionGroups();
			this.payments.show( new actionTypeCollectionView( { collection: this.paymentsCollection } ) );
			this.marketing.show( new actionTypeCollectionView( { collection: this.marketingCollection } ) );
			this.management.show( new actionTypeCollectionView( { collection: this.managementCollection } ) );
			this.crms.show( new actionTypeCollectionView( { collection: this.crmCollection } ) );
			this.notifications.show( new actionTypeCollectionView( { collection: this.notificationsCollection } ) );
			this.automation.show( new actionTypeCollectionView( { collection: this.automationCollection } ) );
		},

		updateInstalledActionGroups: function() {
			this.primaryCollection = new actionTypeCollection(
				this.installedActions.where({group: ''}),
				{
					slug: 'installed',
					nicename: 'Installed Add-on Actions'
				} 
			);
			this.primaryCollection.comparator = 'nicename';
			this.primaryCollection.sort();

			this.coreCollection = new actionTypeCollection(
				this.installedActions.where({group: 'core'}),
				{
					slug: 'core',
					nicename: 'Core Actions'
				} 
			);
		},

		updateAvailableActionGroups: function() {
			this.paymentsCollection = new actionTypeCollection(
				this.availableActions.where({group: 'payments'}),
				{
					slug: 'payments',
					nicename: 'Accept Payments & Donations'
				} 
			);

			this.marketingCollection = new actionTypeCollection(
				this.availableActions.where({group: 'marketing'}),
				{
					slug: 'marketing',
					nicename: 'Email Marketing'
				} 
			);

			this.managementCollection = new actionTypeCollection(
				this.availableActions.where({group: 'management'}),
				{
					slug: 'management',
					nicename: 'User & Submission Management'
				} 
			);

			this.crmCollection = new actionTypeCollection(
				this.availableActions.where({group: 'crms'}),
				{
					slug: 'crms',
					nicename: 'CRMs'
				} 
			);

			this.notificationsCollection = new actionTypeCollection(
				this.availableActions.where({group: 'notifications'}),
				{
					slug: 'notifications',
					nicename: 'Notifications & Workflow'
				} 
			);

			this.automationCollection = new actionTypeCollection(
				this.availableActions.where({group: 'automation'}),
				{
					slug: 'automation',
					nicename: 'Automation'
				} 
			);
		}

	} );

	return view;
} );
